import type { NavPalette } from "@/components/design-switcher/nav-palette";

export const C = {
  flamenco500: "#F05260",
  flamenco400: "#F47781",
  flamenco300: "#F6A2A9",
  flamenco100: "#F7D9DC",
  skyfall500: "#84D5F7",
  skyfall400: "#99DDF9",
  skyfall100: "#CBEFFF",
  mintleaf500: "#4EB969",
  mintleaf400: "#69CB82",
  plumwood500: "#842885",
  plumwood400: "#B666B7",
  plumwood100: "#FBD5FB",
  black: "#111111",
  white: "#FFFFFF",
  offWhite: "#F9F9F9",
} as const;

export const BORDER = `4px solid ${C.black}`;
export const BORDER_THIN = `3px solid ${C.black}`;

export const nav: NavPalette = {
  surface: "rgba(255, 255, 255, 0.96)",
  surfaceHover: "rgba(249, 249, 249, 1)",
  border: "rgba(17, 17, 17, 0.9)",
  text: "#111111",
  textMuted: "rgba(17, 17, 17, 0.72)",
  activeBg: "rgba(251, 213, 251, 0.55)",
  activeText: "#111111",
};

export const KEYFRAMES = `
:root {
  --font-heading: 'Sora', sans-serif;
  --font-body: 'DM Sans', sans-serif;
}

@keyframes v5-spin-slow {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}
@keyframes v5-spin-reverse {
  from { transform: rotate(360deg); }
  to   { transform: rotate(0deg); }
}
@keyframes v5-slide-left {
  from { opacity: 0; transform: translateX(-60px); }
  to   { opacity: 1; transform: translateX(0); }
}
@keyframes v5-slide-right {
  from { opacity: 0; transform: translateX(60px); }
  to   { opacity: 1; transform: translateX(0); }
}
@keyframes v5-slide-up {
  from { opacity: 0; transform: translateY(40px); }
  to   { opacity: 1; transform: translateY(0); }
}
@keyframes v5-float {
  0%, 100% { transform: translateY(0); }
  50%      { transform: translateY(-10px); }
}
`;

export const RESPONSIVE_CSS = `
  @media (max-width: 768px) {
    .v5-featured-card {
      grid-template-columns: 1fr !important;
    }
    .v5-featured-card > div:first-child {
      border-right: none !important;
      border-bottom: 4px solid #111111 !important;
      padding: 24px !important;
    }
    .v5-featured-info {
      padding: 28px 24px !important;
    }
  }

  @media (min-width: 900px) {
    .v5-hero-block {
      display: block !important;
    }
  }
`;

export const VALUE_PROPS = [
  {
    title: "Hear It Right",
    body: "Professional narration guides each word so children absorb proper pronunciation, rhythm, and expression naturally.",
    color: C.skyfall500,
    shape: "circle" as const,
    accent: C.skyfall100,
  },
  {
    title: "Read Along",
    body: "Highlighted text follows the audio in real time, building the eye-ear connection essential for fluent reading.",
    color: C.flamenco500,
    shape: "triangle" as const,
    accent: C.flamenco100,
  },
  {
    title: "Grow Confident",
    body: "Progress tracking and leveled content ensure children move forward at exactly the right pace for lasting growth.",
    color: C.mintleaf500,
    shape: "rect" as const,
    accent: "#D6F5DE",
  },
];

export const LIBRARY_BOOKS = [
  {
    title: "Sunny the Sunflower",
    grade: "Grade 1",
    pages: 16,
    colors: [C.mintleaf500, C.skyfall500, C.flamenco100] as [
      string,
      string,
      string,
    ],
    pattern: "stripes" as const,
    accent: C.mintleaf400,
  },
  {
    title: "Captain Quackers",
    grade: "Grade 2",
    pages: 20,
    colors: [C.flamenco500, C.plumwood400, C.skyfall100] as [
      string,
      string,
      string,
    ],
    pattern: "blocks" as const,
    accent: C.flamenco400,
  },
  {
    title: "The Moon Rabbit",
    grade: "Grade 3",
    pages: 28,
    colors: [C.plumwood500, C.skyfall500, C.mintleaf400] as [
      string,
      string,
      string,
    ],
    pattern: "triangles" as const,
    accent: C.plumwood400,
  },
];
